import { computed, ref } from "vue";
import { useDialog } from "primevue/usedialog";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import type { BusinessEntity } from "@/stores/business-entities-store";
import EntityEditor from "@/components/entities/EntityEditor.vue";
import { useHotKeys } from "./hotkeys";
import { useCurrentEntityManager } from "@/stores/entity-store";

export const useEditEntityDialog = () => {
    const { domain } = useCurrentEntityManager();
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();
    const isVisible = computed(() => Boolean(dialogRef.value?.visible));

    const registerHotKey = () => {
        const { addHotKey } = useHotKeys();

        addHotKey(
            "n d",
            (e) => {
                if (!isVisible.value && domain.value?.identity) {
                    e.preventDefault();
                    open();
                }
            },
            "Open new definition dialog."
        );
    };

    const open = (entity?: BusinessEntity) => {
        dialogRef.value = dialog.open(EntityEditor, {
            props: {
                header: entity ? "Edit definition" : "New definition",
                style: {
                    maxWidth: "600px",
                    width: "80%",
                },
                modal: true,
                maximizable: false,
                draggable: false,
            },
            data: entity,
        });
    };

    return {
        open,
        isVisible,
        registerHotKey,
    };
};
